<bz-button variant="tertiary" tone="primary" size="fit"
           appBringozIdGenerator="quickFilterBtn"
           [disabled]="isDisabled()"
           [ariaLabel]="'Quick Filters' | translate"
           (clicked)="onOpenPanel($event)">
  <span class="layout-row layout-align-start-center filter-item">
    <bz-icon [icon]="icons.quickFilters"></bz-icon>

    @if (!hideDisplay()) {
      @if (selectedId()) {
        <span class="margin-left-5">{{ selectedName() }}</span>
        <bz-icon class="pointer margin-left-5"
                 appBringozIdGenerator="quickFilterResetBtn"
                 [icon]="icons.reset"
                 [label]="'Reset' | translate"
                 (click)="onReset($event)">
        </bz-icon>
      } @else {
        <span class="margin-left-5">{{ (placeholder() || 'Quick Filters') | translate }}</span>
      }
    }
  </span>
</bz-button>
